/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialButton from 'app/components/common/SocialButton.jsx';
import DropDown from 'app/components/common/DropDown.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import GenericItem from 'app/components/DropDownItems/GenericItem.jsx';
import SocialHeader from 'app/components/Headers/SocialHeader.jsx';
import SocialModalHeader from 'app/components/SocialModal/SocialModalHeader.jsx';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import SocialRestoreModule from 'app/modules/SocialRestoreModule.jsx';
import classnames from 'classnames';
import RetweetPanel from 'app/components/common/RetweetPanel.jsx';
import * as _ from 'underscore';
import makeToast from 'app/modules/makeToast.js';
import { feedCadence } from 'app/utility/SuggestFeeds.js';
import { assetBase } from '@/lib/asset-base.ts';
import { networkFromServiceCode } from '@/lib/network-service-codes.ts';
import { outputAccountFromSocial, outputAccountInactive } from '@/lib/output-account.ts';
import { AccountsScreen } from '@/shadcn/components/AddSocialModal/connect-social.tsx';
import { DestinationsStep } from '@/shadcn/components/NewAutomation/DestinationsStep.tsx';


/* The design's rule: below this the whole list is on screen, so a filter is
   noise. */
const DIALOG_SEARCH_THRESHOLD = 10;

class SocialSelection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dropDownFilter: false,
			dropDownSort: false,
			filterLabel: 'All Outputs',
			sortLabel: 'Sort A - Z',
			showTwitterTray: false,
			twitters: [],
			listModeShort: true,
			dialogQuery: '',
			dialogSearchOpen: false,
		};

		this.handleSocialClick = this.handleSocialClick.bind(this);
		this.filterButtonClick = this.filterButtonClick.bind(this);
		this.filterItemHandler = this.filterItemHandler.bind(this);
		this.searchHandler = this.searchHandler.bind(this);
		this.searchFocusHandler = this.searchFocusHandler.bind(this);
		this.sortButtonClick = this.sortButtonClick.bind(this);
		this.sortHandler = this.sortHandler.bind(this);
		this.onConnect = this.onConnect.bind(this);
		this.createFeedHandler = this.createFeedHandler.bind(this);
		this.findTwitters = this.findTwitters.bind(this);
		this.resetHandler = this.resetHandler.bind(this);
		this.onTileSelect = this.onTileSelect.bind(this);
		this.onDialogConnectNew = this.onDialogConnectNew.bind(this);
		this.onTileSelectGroup = this.onTileSelectGroup.bind(this);

	}

	componentDidMount() {

		let showTwitterTray = false,
			twitters = this.findTwitters(this.props),
			twitterCount = 0,
			constants = this.props.app.config.constants;

		for (let i = 0; i < this.props.selectedSocials.length; ++i) {
			let id = this.props.selectedSocials[i];
			let social = _.find(twitters, (social) => {
				return social.id == this.props.selectedSocials[i];
			});
			if (social) {
				++twitterCount;
			}
		}

		this.props.sortStore('socials', 'name', 'ASC', [
			(social) => { return social.activeFlag === 1 || (social.activeFlag === 0 && social.sysActionFlag === 0) },
			(social) => { return social.activeFlag === 0 && social.sysActionFlag === 1 }
		]);


		// determine if the tray should be visible right away
		// in the modal context. if there's more than 1 twitter or if the only twitters are
		// retweeters
		if (twitterCount > 1) {
			showTwitterTray = true;
		}

		if (twitterCount >= 1) {
			let isMasterOutput = false;
			for (var i = 0; i < this.props.outputs.length; ++i) {
				var output = this.props.outputs[i];
				if (output.social.psID == constants.POST_SVC_TWITTER && output.role == constants.OR_ROLE_NORMAL) {
					isMasterOutput = true;
				}
			}
			if (this.props.outputs.length > 0 && !isMasterOutput) {
				showTwitterTray = true;
			}
		}

		if (this.props.serviceId !== constants.POST_SVC_TWITTER) {
			showTwitterTray = false;
		}

		this.setState({
			showTwitterTray,
			twitters
		});

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.socials.list.length != prevProps.socials.list.length) {
			this.setState({
				twitters: this.findTwitters(this.props)
			});
		}

		if (prevProps.mainTweeter != this.props.mainTweeter && this.props.mainTweeter == 0) {
			this.setState({
				showTwitterTray: false
			});
		}


	}

	findTwitters(props) {
		let constants = this.props.app.config.constants,
			twitters = [];

		for (var i = 0; i < props.socials.list.length; ++i) {
			if (props.socials.list[i].psID == constants.POST_SVC_TWITTER) {
				twitters.push(props.socials.list[i]);
			}
		}

		return twitters;

	}

	handleSocialClick(e) {
		let constants = this.props.app.config.constants,
			showTwitterTray = false,
			twitterCount = 0;

		if (e.currentTarget.dataset.type == constants.POST_SVC_TWITTER) {
			if (this.props.selectedSocials.indexOf(e.currentTarget.dataset.id) === -1) {
				twitterCount = 1;
			} else {
				twitterCount = -1;
			}

			for (var i = 0; i < this.props.selectedSocials.length; ++i) {
				var id = this.props.selectedSocials[i];
				var social = _.find(this.state.twitters, function (social) {
					return social.id == this.props.selectedSocials[i];
				}.bind(this));
				if (social && social.id !== parseInt(e.currentTarget.dataset.id)) {
					++twitterCount;
				}
			}

			if (e.currentTarget.dataset.id == this.props.mainTweeter) {
				if (twitterCount > 1 && this.props.context !== 'bulk-modal') {
					this.props.resetTwitters();
					return;
				}
			}

			if (twitterCount > 1 && this.props.twitterInput === false) {
				showTwitterTray = true;
			}

			this.setState({
				showTwitterTray
			});

		}

		if (e.currentTarget.dataset.type == constants.POST_SVC_YOUTUBE) {
			let youTubeCount = 0,
				selectedId = parseInt(e.currentTarget.dataset.id);

			this.props.socials.list.map((social) => {
				if (social.psID === constants.POST_SVC_YOUTUBE && this.props.selectedSocials.indexOf(social.id) !== -1) {
					++youTubeCount;
				}
			});

			if (this.props.selectedSocials.indexOf(selectedId) === -1 && youTubeCount) {
				return;
			}
		}

		/*
		 * An inactive account can't be posted to, so on a surface that opted into
		 * `allowReconnect` a click on one asks to bring it back rather than to
		 * select it. Nothing is selected on the way in, so there is nothing to undo
		 * if the prompt is dismissed; the account is selectable on the next click,
		 * once it is actually active.
		 *
		 * Off by default because most of this component's hosts aren't choosing
		 * outputs at all — in Stats the click is a filter and in QueueTabs it is a
		 * tab, and neither should start an OAuth redirect.
		 */
		if (this.props.allowReconnect) {
			let social = this.props.socials.list.find((candidate) => {
					return String(candidate.id) === String(e.currentTarget.dataset.id);
				});

			if (social && parseInt(social.activeFlag, 10) === 0) {
				this.props.restoreSocial(social);

				return;
			}
		}

		if (_.isFunction(this.props.socialClickHandler)) {
			this.props.socialClickHandler.call(this, e);
		}

	}

	filterButtonClick() {
		let dropDownSort = this.state.dropDownSort;

		if (!this.state.dropDownFilter && dropDownSort) {
			dropDownSort = false;
		}

		this.setState({
			dropDownFilter: (this.state.dropDownFilter) ? false : true,
			dropDownSort
		});
	}

	sortButtonClick() {
		let dropDownFilter = this.state.dropDownFilter;

		if (!this.state.dropDownSort && dropDownFilter) {
			dropDownFilter = false;
		}

		this.setState({
			dropDownFilter,
			dropDownSort: (this.state.dropDownSort) ? false : true
		});

	}

	filterItemHandler(social, e) {
		this.props.filterHandler(e, social.type);

		this.setState({
			filterLabel: social.name,
			dropDownFilter: false,
			resetSearch: true
		});

	}

	searchHandler(e, search) {

		this.setState({
			filterLabel: 'All Outputs'
		});

		this.props.searchHandler(e, search);

	}

	sortHandler(sort, e) {
		let nextLabel = this.state.sortLabel;

		if (sort.key === 'postGroup') {
			this.props.showPostGroupModal();
		} else {
			nextLabel = sort.name;
			if (sort.key === 'type') {
				this.props.sortStore('socials', 'psID', 'ASC');
			} else {
				let dir = "ASC";
				if (sort.key === 'z-a') {
					dir = "DESC";
				}
				this.props.sortStore('socials', 'name', dir);
			}
		}

		this.setState({
			sortLabel: nextLabel,
			dropDownSort: false
		});
	}

	searchFocusHandler(e) {

		this.setState({
			resetSearch: false
		});

	}

	resetHandler(id) {
		if (id === "social-filter") {
			this.setState({
				dropDownFilter: false
			});
		} else if (id === 'social-sort') {
			this.setState({
				dropDownSort: false
			});
		}
	}

	onConnect(e) {

		this.props.filterHandler(e, '');
		this.setState({
			filterLabel: 'All Outputs',
			resetSearch: true
		});

		this.props.connectHandler();

	}

	createFeedHandler() {
		this.props.connectHandler('connect');
	}

	/*
	 * The tile grid reports an OutputAccount; handleSocialClick wants the
	 * data-id / data-type pair the legacy <li> carried. Synthesising that pair
	 * here, rather than duplicating the click rules, keeps the twitter tray, the
	 * retweet reset and the caller's own selection handler behaving exactly as
	 * they do in the legacy list — ids included, which a real dataset would also
	 * have handed over as strings.
	 */
	onTileSelect(account) {
		let social = this.props.socials.list.find((candidate) => {
				return String(candidate.id) === account.id;
			});

		if (social === undefined) {
			return;
		}

		this.handleSocialClick({
			currentTarget: {
				dataset: {
					id: String(social.id),
					type: String(social.psID)
				}
			}
		});

	}

	/*
	 * Applying a saved posting group: select whichever of its members this
	 * account actually has.
	 *
	 * Additive, never subtractive. The group is a shortcut for "and these too",
	 * so a member that is already chosen is left alone rather than toggled off —
	 * which is why this goes to socialClickHandler with a null event instead of
	 * through onTileSelect. That null-event path exists for exactly this (see
	 * RouteNew.onSocialClick: "if the event isn't passed in, this call is coming
	 * from the posting groups modal, don't unselect any previously selected
	 * socials"), and it is also what keeps the retweet bookkeeping intact.
	 *
	 * Two things the legacy modal did not do. Members this account no longer has
	 * are skipped — it pushed those ids onto the route anyway, building a route
	 * that referred to a social the user could not see. And blocked members are
	 * skipped, for the same reason their own tiles refuse a click; bulk-selecting
	 * an output the backend will reject is not a shortcut.
	 *
	 * The membership tests read this.props.selectedSocials mid-loop on purpose:
	 * it IS RouteNew's route.socials array, which onSocialClick pushes onto in
	 * place, so each iteration sees what the ones before it added. Only the
	 * removal branch replaces that array, and nothing here removes.
	 */
	onTileSelectGroup(group) {
		let constants = this.props.app.config.constants,
			members = (group.accountIds || []).map((id) => { return parseInt(id, 10); }),
			present = this.props.socials.list.filter((social) => {
				return members.indexOf(parseInt(social.id, 10)) !== -1;
			}),
			before = this.props.selectedSocials.length,
			twitterCount = 0,
			added = 0;

		for (let i = 0; i < present.length; ++i) {
			let social = present[i];

			if (this.props.selectedSocials.indexOf(social.id) !== -1) {
				continue;
			}

			if (this.tileBlockedReason(social)) {
				continue;
			}

			if (_.isFunction(this.props.socialClickHandler)) {
				this.props.socialClickHandler.call(this, null, parseInt(social.id, 10));
			}
		}

		added = this.props.selectedSocials.length - before;

		if (!added) {
			makeToast('', 'info', {
				title: `Nothing to add from ${group.name}`,
				description: present.length
					? "Those outputs are already selected, or aren't available for this source."
					: "This account doesn't have the outputs in that group."
			});

			return;
		}

		/*
		 * The retweet tray, which handleSocialClick would have opened had these
		 * been individual clicks. Without it a group of two or more X accounts
		 * leaves mainTweeter set from the first one with no way to change it.
		 */
		for (let i = 0; i < this.props.selectedSocials.length; ++i) {
			let selected = this.props.socials.list.find((candidate) => {
				return candidate.id === this.props.selectedSocials[i];
			});

			if (selected && selected.psID == constants.POST_SVC_TWITTER) {
				++twitterCount;
			}
		}

		if (twitterCount > 1 && this.props.twitterInput === false) {
			this.setState({
				showTwitterTray: true
			});
		}

	}

	/* One social record as the destination tile's account. */
	tileAccount(social) {
		let constants = this.props.app.config.constants,
			retweet = false;

		if (this.props.mainTweeter != 0 && this.props.mainTweeter != social.id && social.psID == constants.POST_SVC_TWITTER) {
			retweet = true;
		}

		if (this.props.twitterInput && social.psID == constants.POST_SVC_TWITTER) {
			retweet = true;
		}

		if (this.props.singleTwitter === true) {
			retweet = false;
		}

		return outputAccountFromSocial(social, {
			constants: constants,
			selected: this.props.selectedSocials.indexOf(social.id) !== -1,
			inactive: outputAccountInactive(social),
			retweet: retweet,
			disabledReason: this.tileBlockedReason(social)
		});

	}

	/*
	 * Why this account can't be picked, or '' when it can.
	 *
	 * The same three rules the legacy list draws as a .social-tooltip while
	 * dropping the click handler, in the same order — the tile takes the reason
	 * as its own tooltip. Only the rules that can fire while choosing an
	 * automation's destinations are here: the reddit and single-twitter cases
	 * belong to the post modal, which still renders the legacy list.
	 */
	tileBlockedReason(social) {
		let constants = this.props.app.config.constants,
			inputs = (this.props.route !== undefined && this.props.route.inputs !== undefined) ? this.props.route.inputs : [],
			hasYouTubeInput = false,
			youTubeSelected = 0,
			youTubeRestrictedOutputs = [
				constants.POST_SVC_YOUTUBE,
				constants.POST_SVC_TIKTOK,
				constants.POST_SVC_INSTAGRAM_BUSINESS,
				constants.POST_SVC_SNAPCHAT
			];

		for (let i = 0; i < inputs.length; ++i) {
			if (inputs[i].type === constants.INPUT_TYPE_YOUTUBE) {
				hasYouTubeInput = true;
			}
			if (inputs[i].externalID !== undefined && inputs[i].externalID === social.externalID) {
				return 'Selecting this output would create a posting loop.';
			}
		}

		if (hasYouTubeInput && youTubeRestrictedOutputs.indexOf(social.psID) !== -1) {
			return "YouTube posts can't be shared to " + ConstantMixin.getPostServiceNameByCode(social.psID);
		}

		if (social.psID === constants.POST_SVC_YOUTUBE && this.props.selectedSocials.indexOf(social.id) === -1) {
			this.props.socials.list.map((candidate) => {
				if (candidate.psID === constants.POST_SVC_YOUTUBE && this.props.selectedSocials.indexOf(candidate.id) !== -1) {
					++youTubeSelected;
				}
			});

			if (youTubeSelected > 0) {
				return 'Choose one YouTube channel per feed.';
			}
		}

		return '';

	}

	/*
	 * The network filter's rows, from the store's per-service counts.
	 *
	 * Two service codes can share one brand mark — Instagram and Instagram
	 * Professional both draw `instagram` — and the filter matches on the mark, so
	 * their rows merge into one instead of listing two filters that do the same
	 * thing. The store's trailing "All Outputs" total is dropped: the step draws
	 * that row itself.
	 */
	tileFilterCounts() {
		let rows = [];

		(this.props.socials.counts || []).map((entry) => {
			let network = networkFromServiceCode(entry.type),
				existing = null;

			if (entry.type === '' || network === null) {
				return;
			}

			existing = rows.find((row) => { return row.network === network; });

			if (existing !== undefined) {
				existing.count += entry.count;
			} else {
				rows.push({
					network: network,
					label: entry.name,
					count: entry.count
				});
			}
		});

		return rows;

	}

	/* Saved posting groups. The step offers them as a bulk-select shortcut — it
	   does not narrow the grid to them. See onTileSelectGroup. */
	tilePostingGroups() {
		return (this.props.postgroups || []).map((group) => {
			return {
				id: String(group.id),
				name: group.name,
				accountIds: (group.group || []).map((id) => { return String(id); })
			};
		});

	}

	/* The chip above the grid: the automation's input. A feed carries its title,
	   a social input its name. */
	tileSource() {
		let inputs = (this.props.route !== undefined && this.props.route.inputs !== undefined) ? this.props.route.inputs : [],
			input = (inputs.length) ? inputs[0] : null,
			name = '';

		if (input === null) {
			return {name: 'Your source', monogram: '?'};
		}

		name = input.title || input.name || input.url || 'Your source';

		return {
			name: name,
			monogram: String(name).trim().charAt(0).toUpperCase() || '?',
			network: networkFromServiceCode(input.subtype || input.type) || undefined,
			/* Same cadence the post-preview and review chips show — see
			   connectedSourceFromInput. RouteNew attaches inputVelocity when the
			   feed validates, so a social input simply has none. */
			velocity: feedCadence(input.inputVelocity) || undefined
		};

	}

	/*
	 * The new-automation destinations step (shadcn/NewAutomation/DestinationsStep),
	 * opted into with `tile`. It replaces this component's search/sort/filter
	 * header, its "Post to N socials" line and its <ul> of SocialButtons.
	 * Everything that is not artwork stays here: the click gating, the retweet
	 * tray, the connect handler and the route-create error.
	 *
	 * Narrowing moves INTO the step, which owns search, network filter, sort and
	 * posting group as local state over the accounts it is handed. So this path
	 * feeds it `socials.list` and never `socials.filteredList` — the redux filter
	 * the legacy header drives is simply unused here, which is also why nothing
	 * clears it on the way in.
	 */
	renderTileStep() {
		/*
		 * The step's own empty state is unreachable from here: CreateFeedSocial
		 * renders TypeSelection instead when the account has no socials at all,
		 * and that is what carries the per-network OAuth, the Mastodon handle and
		 * Bluesky credential views, and the entitlement gates. The three empty
		 * props below are passed only because the step requires them.
		 */
		return (
			<div>
				{this.renderRouteCreateError()}
				<DestinationsStep
					base={assetBase(this.props.app.config)}
					source={this.tileSource()}
					accounts={this.props.socials.list.map((social) => { return this.tileAccount(social); })}
					showToolbar={this.props.displayHeader}
					filterOpen={false}
					filterCounts={this.tileFilterCounts()}
					postingGroups={this.tilePostingGroups()}
					emptyNetworks={[]}
					moreDestinations={[]}
					moreDestinationsOpen={false}
					onSelectAccount={this.onTileSelect}
					onSelectGroup={this.onTileSelectGroup}
					onConnectNew={this.onConnect} />
				{this.renderTwitterTray()}
			</div>
		);

	}

	/*
	 * The connect dialog's "accounts" screen (shadcn/AddSocialModal), chosen with
	 * `variant="dialog"`. A sibling of renderTileStep rather than a mode of it:
	 * the wizard step carries a whole toolbar — search, network filter, sort,
	 * posting groups — drawn for a full-width step, and the dialog's card is
	 * 512px with a single collapsed search.
	 *
	 * Returned as a FRAGMENT: the caller drops it into the dialog card, which is a
	 * flex column whose gap spaces the header, body and footer apart. A wrapper
	 * element here would collapse that.
	 *
	 * Narrowing is local, as it is for the step — `socials.list` filtered by the
	 * chosen service and the typed query, never `socials.filteredList`. The redux
	 * filter would fall back to the unfiltered list when a search matches nothing
	 * (see the legacy path below), so a search with no matches would silently
	 * show every account instead of saying so.
	 */
	renderDialogStep() {
		return (
			<React.Fragment>
				<AccountsScreen
					network={networkFromServiceCode(this.props.serviceId) || "facebook"}
					accounts={this.dialogAccounts()}
					query={this.state.dialogQuery}
					showSearch={this.dialogSocials(true).length > DIALOG_SEARCH_THRESHOLD}
					searchOpen={this.state.dialogSearchOpen}
					searchPlaceholder={this.dialogSearchPlaceholder()}
					showConnectNew={this.dialogShowConnectNew()}
					emptyMessage={this.dialogEmptyMessage()}
					onSelectAccount={this.onTileSelect}
					onConnectNew={this.onDialogConnectNew}
					onSearchChange={(query) => { this.setState({dialogQuery: query}); }}
					onSearchToggle={(open) => { this.setState({dialogSearchOpen: open}); }} />
				{this.renderTwitterTray()}
			</React.Fragment>
		);

	}

	/*
	 * "Connect New" on the dialog's account screen adds another account of the
	 * service being looked at — it doesn't go back to the network picker. This is
	 * what the legacy header's connect button did, including the one service it
	 * special-cases: Mastodon collects a handle from us first, where the rest
	 * either start an OAuth hop or are routed onward by connectService itself
	 * (Bluesky to its credential form, Feed to its settings).
	 *
	 * Not `onConnect`, which belongs to the legacy list's own connect control and
	 * calls a `filterHandler` this screen has no reason to be passed.
	 */
	onDialogConnectNew() {
		let constants = this.props.app.config.constants,
			serviceId = parseInt(this.props.serviceId, 10) || 0;

		if (!serviceId) {
			this.props.switchView('chooseType');
			return;
		}

		if (serviceId === constants.POST_SVC_MASTODON) {
			this.props.switchView('providehandle');
			return;
		}

		ConnectMixin.connectService.call(this, {
			preventDefault: () => {},
			currentTarget: {
				dataset: {
					serviceid: serviceId,
					direct: 'true'
				}
			}
		});

	}

	/*
	 * Hidden once this account's X limit is reached, as the legacy header did —
	 * offering a connect that the save would refuse is worse than not offering
	 * it.
	 */
	dialogShowConnectNew() {
		let constants = this.props.app.config.constants,
			serviceId = parseInt(this.props.serviceId, 10) || 0,
			selectedTwitters = 0;

		if (this.props.showConnectNew === false) {
			return false;
		}

		if (serviceId !== constants.POST_SVC_TWITTER) {
			return true;
		}

		if (this.props.twitterMaxedOut) {
			return false;
		}

		for (let i = 0; i < this.props.selectedSocials.length; ++i) {
			let social = _.find(this.props.socials.list, (candidate) => {
				return this.props.selectedSocials[i] == candidate.id;
			});

			if (social && social.psID == constants.POST_SVC_TWITTER) {
				++selectedTwitters;
			}
		}

		return selectedTwitters < constants.MAX_TWITTER_OUTPUTS;

	}

	/*
	 * The accounts the dialog lists. `ignoreQuery` asks for the set the search
	 * box itself is judged against — whether to offer search at all depends on
	 * how many accounts exist, not on how many the current query leaves.
	 */
	dialogSocials(ignoreQuery) {
		let constants = this.props.app.config.constants,
			serviceId = parseInt(this.props.serviceId, 10) || 0,
			query = (ignoreQuery) ? '' : this.state.dialogQuery.trim().toLowerCase();

		return this.props.socials.list.filter((social) => {
			if (serviceId && parseInt(social.psID, 10) !== serviceId) {
				return false;
			}
			// the importer asks for no X while it's importing to the EverQueue, which X's terms rule out
			if (this.props.noTwitter && parseInt(social.psID, 10) === constants.POST_SVC_TWITTER) {
				return false;
			}
			if (query !== '' && String(social.name || '').toLowerCase().indexOf(query) === -1) {
				return false;
			}

			return true;
		});

	}

	dialogAccounts() {
		return this.dialogSocials(false).map((social) => { return this.tileAccount(social); });
	}

	dialogSearchPlaceholder() {
		let serviceId = parseInt(this.props.serviceId, 10) || 0;

		return (serviceId)
			? 'Search connected ' + ConstantMixin.getPostServiceNameByCode(serviceId) + ' socials'
			: 'Search connected socials';
	}

	dialogEmptyMessage() {
		if (this.state.dialogQuery.trim() !== '') {
			return 'No socials match that search.';
		}

		return 'Nothing connected here yet — connect one to continue.';

	}

	/*
	 * The error arrives as a descriptor ({kind: 'loop', socialName}) rather than a
	 * node, because RouteNew's state is persisted to localStorage across the
	 * social-connect redirect and JSON drops a React element's $$typeof. Anything
	 * unrecognised — including an element left in localStorage by an older build —
	 * falls through to the generic message rather than being rendered as a child.
	 */
	renderRouteCreateError() {
		let error = this.props.routeCreateError;

		if (error === undefined || error === null) {
			return null;
		}

		let message = 'There was a problem creating your route';

		if (error.kind === 'loop') {
			message = (
				<span>
					<strong>Warning!</strong> You nearly created an endless posting loop.<br/>
					<strong>{error.socialName}</strong> is no longer selected as an output.
				</span>
			);
		}

		return (
			<div className="social-settings-reminder route-create-error">
				{message}
			</div>
		);

	}

	/* Picking which of several selected X accounts is the one that posts, the
	   rest retweeting it. No design frame, so both flows draw the legacy panel. */
	renderTwitterTray() {
		if (!this.state.showTwitterTray || this.props.twitterInput) {
			return null;
		}

		return (
			<RetweetPanel
				{...this.props}
				selectedSocials={this.props.selectedSocials}
				mainTweeter={this.props.mainTweeter}
				setMainTweeter={this.props.setMainTweeter}
				context={this.props.context}
				socialClickHandler={this.props.socialClickHandler}
				handleSocialClick={this.handleSocialClick} />
		);

	}

	render() {
		if (this.props.variant === 'dialog') {
			return this.renderDialogStep();
		}

		if (this.props.tile) {
			return this.renderTileStep();
		}

		let saveClass = classnames(
			'btn-primary btn-modal',
			{
				'active': this.props.isDirty
			}
		),
			saveHandler = null,
			DropDownFilter = null,
			DropDownSort = null,
			actionButton = null,
			selectionHeader = null,
			connectButton = null,
			selectionListClass = 'social-selection-list',
			socialHeader = null,
			twitterTray = null,
			constants = this.props.app.config.constants,
			socials = (this.props.socials.filteredList.length) ? this.props.socials.filteredList : this.props.socials.list;

		if (this.props.isDirty) {
			saveHandler = this.props.saveHandler;
		}

		if (this.state.dropDownFilter) {
			DropDownFilter = (
				<DropDown
					id="social-filter"
					items={this.props.socials.counts}
					itemElement={FilterItem}
					clickHandler={this.filterItemHandler}
					dropDownClass="filter-dd"
					resetHandler={this.resetHandler} />
			);
		}

		if (this.state.dropDownSort) {
			DropDownSort = (
				<DropDown
					id="social-sort"
					items={[
						{ key: 'a-z', name: 'Sort A - Z' },
						{ key: 'z-a', name: 'Sort Z - A' },
						{ key: 'type', name: 'Sort By Type' },
						{ key: 'postGroup', name: 'Choose Posting Group' }
					]}
					itemElement={GenericItem}
					clickHandler={this.sortHandler}
					dropDownClass="sort-dd short"
					resetHandler={this.resetHandler} />
			);
		}

		if (["modal", "bulk-modal", "list-add", "post-groups"].indexOf(this.props.context) === -1) {
			let shareMessage = "Select a social account",
				sharePlural = "social";
			if (this.props.selectedSocials.length >= 1) {
				if (this.props.selectedSocials.length > 1) {
					sharePlural = "socials";
				}
				shareMessage = <span>Post to <span className="number-callout">{this.props.selectedSocials.length}</span> {sharePlural}</span>;
			}
			selectionHeader = (
				<div>
					<div className="social-selection-header">
						{this.props.user.detail.routeViewType === constants.ROUTE_VIEW_ADVANCED ? (
							<div className="social-selection-headline">
								Which social channels should we share to?
							</div>
						) : null}
						{shareMessage}
					</div>
				</div>
			);
		}

		if (this.props.context === "modal" || this.props.context === 'list-add') {
			selectionListClass += " in-modal";
			actionButton = (
				<div className="control save">
					<div className={saveClass} onClick={saveHandler}>update</div>
				</div>
			);
			if (this.props.serviceId === constants.POST_SVC_MASTODON) {
				connectButton = (
					<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
						<SocialButton
							{...this.props}
							connect={true}
							connectAction={() => {
								this.props.switchView('providehandle');
							}}
							direct={true}
							tile={true}
							serviceId={this.props.serviceId} />
					</li>
				);
			} else {
				connectButton = (
					<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
						<SocialButton
							{...this.props}
							connect={true}
							connectAction={ConnectMixin.connectService.bind(this)}
							direct={true}
							tile={true}
							serviceId={this.props.serviceId} />
					</li>
				);
			}

		} else if (this.props.context === "input") {
			actionButton = (
				<div className="control new" onClick={this.onConnect} role="button" aria-label="connect new">
					<span className="va-helper"></span>
					<i className="fa fa-plus-square new-icon"></i> Connect Social
				</div>
			);
			connectButton = (
				<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
					<SocialButton
						{...this.props}
						connect={true}
						tile={true}
						connectAction={this.props.connectHandler} />
				</li>
			);
		} else if (this.props.context === "stats" || this.props.context === "queue" || this.props.context === "post-modal") {
			selectionHeader = null;
			if (this.props.context === "post-modal") {
				selectionListClass += " in-modal";
			}
		}

		if (this.props.displayHeader) {
			if (this.props.context === 'modal' || this.props.context === 'list-add') {
				socialHeader = (
					<SocialModalHeader
						{...this.props}
						serviceId={this.props.serviceId}
						searchHandler={this.searchHandler}
						focusHandler={this.searchFocusHandler}
						resetSearch={this.state.resetSearch}
						connectAction={this.props.connectHandler}
						switchView={this.props.switchView}
						recordPath={this.props.setPath}
						singleTwitter={this.props.singleTwitter}
						twitterMaxedOut={this.props.twitterMaxedOut} />
				);
			} else {
				let showFilter = false;
				if (this.props.context === 'queue' || this.props.context === 'bulk-modal') {
					showFilter = true;
				}
				if (this.props.context === "input") {
					socialHeader = (
						<SocialHeader
							{...this.props}
							showFilter={showFilter}
							searchCallback={this.searchHandler}
							actionButton={actionButton}
							filterDropdown={DropDownFilter}
							context={this.props.context}
							focusHandler={this.searchFocusHandler}
							resetSearch={this.state.resetSearch}
							serviceId={this.props.serviceId}
							filterLabel={this.state.filterLabel}
							filterButtonCallback={this.filterButtonClick}
							sortDropdown={DropDownSort}
							sortLabel={this.state.sortLabel}
							sortButtonCallback={this.sortButtonClick} />
					);
				} else {
					socialHeader = (
						<SocialHeader
							{...this.props}
							showFilter={showFilter}
							searchCallback={this.searchHandler}
							actionButton={actionButton}
							filterDropdown={DropDownFilter}
							context={this.props.context}
							focusHandler={this.searchFocusHandler}
							resetSearch={this.state.resetSearch}
							serviceId={this.props.serviceId}
							filterLabel={this.state.filterLabel}
							filterButtonCallback={this.filterButtonClick} />
					);
				}

			}

		}

		if (this.props.twitterMaxedOut) {
			connectButton = null;
		}

		twitterTray = this.renderTwitterTray();

		let listClass = 'detail-list clearfix',
			listHeightToggle = null,
			listToggleLabel = (this.state.listModeShort) ? 'show more' : 'show less';

		if (this.props.toggleListHeight) {
			if (this.state.listModeShort) {
				listClass += ' short';
			}
			listHeightToggle = (
				<div className="socials-list-toggle">
					<div className="socials-list-button" onClick={(e) => {
						let nextToggleState = this.state.listModeShort ? false : true;

						this.setState({
							listModeShort: nextToggleState
						});
					}}>
						{listToggleLabel}
					</div>
				</div>
			);
		} else if (['modal', 'list', 'input'].indexOf(this.props.context) !== -1) {
			if (this.props.displayHeader) {
				listClass += ' large';
			}
		}

		let routeCreateError = this.renderRouteCreateError();

		return (
			<div>
				{socialHeader}
				{routeCreateError}
				<div className={selectionListClass}>
					{selectionHeader}
					<ul className={listClass}>
						{connectButton}
						{socials.map(function (social, i) {
							let unselected = (this.props.selectedSocials.find((item) => { return social.id === item; }) === undefined) ? true : false,
								buttonClass = 'list-item social',
								customSubLabel = '',
								percentFull = 0,
								constants = this.props.app.config.constants,
								retweet = false,
								clickHandler = this.handleSocialClick,
								rolloverInfo = null,
								inputIds = [],
								hasYouTubeInput = false,
								youTubeRestrictedOutputs = [
									constants.POST_SVC_YOUTUBE,
									constants.POST_SVC_TIKTOK,
									constants.POST_SVC_INSTAGRAM_BUSINESS,
									constants.POST_SVC_SNAPCHAT
								];

							if (this.props.route !== undefined && this.props.route.inputs.length) {
								for (let i = 0; i < this.props.route.inputs.length; ++i) {
									let input = this.props.route.inputs[i];
									if (input.type === constants.INPUT_TYPE_YOUTUBE) {
										hasYouTubeInput = true;
									}
									if (input.externalID !== undefined) {
										inputIds.push(input.externalID);
									}
								}
							}

							if (inputIds.indexOf(social.externalID) !== -1) {
								rolloverInfo = (
									<div className="social-tooltip">
										Selecting this output would create a posting loop.
									</div>
								);
								clickHandler = null;
							}


							if (this.props.context === "post-modal" && (social.psID == constants.POST_SVC_REDDIT)) {
								rolloverInfo = (
									<div className="social-tooltip">
										Reddit is not currently available for direct posting.
									</div>
								);
								clickHandler = null;
							}

							if (this.props.context === 'post-modal' && (social.psID == constants.POST_SVC_TWITTER)) {
								if (this.props.twitterCount && unselected) {
									rolloverInfo = (
										<div className="social-tooltip">
											Due to Twitter policy, only a single twitter may be selected.
										</div>
									);
								}
							}

							if (!rolloverInfo) {
								if (hasYouTubeInput && ['queue', 'stats'].indexOf(this.props.context) === -1 && youTubeRestrictedOutputs.indexOf(social.psID) !== -1) {
									let socialName = ConstantMixin.getPostServiceNameByCode(social.psID);
									rolloverInfo = (
										<div className="social-tooltip">
											YouTube posts can't be shared to {socialName}
										</div>
									);
									clickHandler = null;
								}
							}

							if (!rolloverInfo) {
								let youTubeCount = 0;
								if (social.psID === constants.POST_SVC_YOUTUBE) {
									this.props.socials.list.map((social) => {
										if (social.psID === constants.POST_SVC_YOUTUBE &&
											this.props.selectedSocials.indexOf(social.id) !== -1) {
											++youTubeCount;
										}
									});
									if (youTubeCount > 0 && unselected) {
										rolloverInfo = (
											<div className="social-tooltip">
												Choose one YouTube channel per feed.
											</div>
										);
										clickHandler = null;
									}
								}
							}

							if (this.props.onlyDisplaySelectedSocials) {
								if (unselected) {
									return null;
								}
							}

							if (this.props.mainTweeter != 0 && this.props.mainTweeter != social.id && social.psID == constants.POST_SVC_TWITTER) {
								retweet = true;
							}

							if (this.props.twitterInput && social.psID == constants.POST_SVC_TWITTER) {
								retweet = true;
							}

							if (this.props.singleTwitter === true) {
								retweet = false;
							}

							if (this.props.context === 'queue') {
								buttonClass += " queue";
								percentFull = (parseInt(social.qCount, 10) / parseInt(this.props.user.perms.resources.qLimit, 10)) * 100;
								if (isNaN(percentFull)) {
									percentFull = 0;
								}
								customSubLabel = percentFull.toFixed(0) + "% full";
							}

							return (
								<li key={i} onClick={clickHandler} data-id={social.id} data-type={social.psID} className={buttonClass} role="button" aria-label={social.name} aria-pressed={!unselected}>
									<SocialButton
										{...this.props}
										social={social}
										unselected={unselected}
										context={this.props.context}
										selected={!unselected}
										customSubLabel={customSubLabel}
										retweet={retweet}
										tile={true}
										user={this.props.user} />
									{rolloverInfo}
								</li>
							)
						}, this)}
					</ul>
					{listHeightToggle}
				</div>
				{twitterTray}
			</div>
		);
	}
};

SocialSelection.displayName = "SocialSelection";

SocialSelection.propTypes = {
	displayHeader: PropTypes.bool,
	socials: PropTypes.object,
	outputs: PropTypes.array,
	searchHandler: PropTypes.func,
	filterHandler: PropTypes.func,
	socialClickHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	isDirty: PropTypes.bool,
	selectedSocials: PropTypes.array,
	context: PropTypes.string,
	connectHandler: PropTypes.func,
	servcieId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	twitterInput: PropTypes.bool,
	onlyDisplaySelectedSocials: PropTypes.bool,
	singleTwitter: PropTypes.bool,
	mainTweeter: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	setMainTweeter: PropTypes.func,
	toggleListHeight: PropTypes.bool,
	tile: PropTypes.bool,
	variant: PropTypes.oneOf(['list', 'dialog']),
	allowReconnect: PropTypes.bool,
	showConnectNew: PropTypes.bool,
	routeCreateError: PropTypes.shape({
		kind: PropTypes.oneOf(['default', 'loop']),
		socialName: PropTypes.string
	})
};

SocialSelection.defaultProps = {
	displayHeader: true,
	socials: {},
	outputs: [],
	routeId: 0,
	socialClickHandler: null,
	saveHandler: null,
	isDirty: false,
	selectedSocials: [],
	context: "modal",
	connectHandler: null,
	resetSearch: false,
	serviceId: 0,
	twitterInput: false,
	onlyDisplaySelectedSocials: false,
	singleTwitter: false,
	mainTweeter: 0,
	setMainTweeter: () => { },
	topButton: null,
	toggleListHeight: false,
	variant: 'list',
	allowReconnect: false,
	tile: false
};

/*
 * SocialRestoreModule sits inside SubscriptionModule: the plan check it runs
 * before reactivating needs the showUpgradeModal that SubscriptionModule adds.
 */
export default SubscriptionModule(SocialRestoreModule(SocialSelection));
